/*
 * The reconnect schedule of protocol.md §2.10: 0.5 → 1 → 2 → 4 → 8 → 15 → 30 s, each drawn
 * ±30 % so a restart does not bring every tab back on the same millisecond, and held at the last
 * step until a connection succeeds.
 */

export const BACKOFF_STEPS_MS: readonly number[] = [500, 1000, 2000, 4000, 8000, 15000, 30000]

export const BACKOFF_JITTER = 0.3

export class Backoff {
	private attempt = 0
	private readonly random: () => number

	constructor(random: () => number = Math.random) {
		this.random = random
	}

	/** The delay before the next dial; each call advances the schedule. */
	next(): number {
		const index = Math.min(this.attempt, BACKOFF_STEPS_MS.length - 1)
		this.attempt++
		return jitter(BACKOFF_STEPS_MS[index] ?? 0, this.random)
	}

	/** Called on a successful connection: the next failure starts the schedule over. */
	reset(): void {
		this.attempt = 0
	}
}

/** `base` moved by up to ±BACKOFF_JITTER of itself; `random` is [0, 1). */
export function jitter(base: number, random: () => number = Math.random): number {
	const spread = (random() * 2 - 1) * BACKOFF_JITTER
	return Math.round(base * (1 + spread))
}
